import type { NextPage } from 'next';

import { useState, useRef, useEffect, useCallback } from 'react';

import { useTranslation } from 'next-i18next';

import Image from 'next/image';

import styles from './../styles/OldAppbar.module.scss';
import SundoseLogo from './../public/images/new-logo.svg';
import HamburgerIcon from './../public/images/hamburger.svg';
import ProfileIcon from './../public/images/profile.svg';
import DropdownIcon from './../public/images/dropdown.svg';

import UELogo from './../public/images/ue.png';

import CtaButton from './CtaButton';
import Link from 'next/link';
import { useRouter } from 'next/router';
import LanguagePicker from './LanguagePicker';

const Appbar: NextPage = () => {
  const [sticky, setSticky] = useState(false);
  const [nav, setNav] = useState(false);

  const { t } = useTranslation('common');

  const appbarRef = useRef();

  const onScroll = useCallback(() => {
    if (appbarRef.current) {
      // @ts-ignore
      const h = appbarRef.current.clientHeight;
      const isSticky = window.scrollY > 2 * h;

      if (sticky !== isSticky) {
        setSticky(isSticky);
      }
    }
  }, [sticky]);

  useEffect(() => {
    window.addEventListener('scroll', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, [onScroll]);

  const { locale } = useRouter();

  const links = (
    <>
      <div className={`dropdown ${styles.navDropdown}`}>
        <Link href={`/${locale}/product`} passHref>
          <div className={`dropdown-menu ${styles.navDropdownMenu}`}>
            {t('mobile-menu-2nd')}
            <Image src={DropdownIcon} alt={'Dropdown icon'} />
          </div>
        </Link>
        <div className={`dropdown-content ${styles.navDropdownContent}`}>
          <Link href={`/${locale}/product`}>{t('mobile-menu-2nd-item-1')}</Link>
          <Link href={`/${locale}/product#how-it-works`}>
            {t('mobile-menu-2nd-item-2')}
          </Link>
          <Link href={`/${locale}/product#reviews`}>
            {t('mobile-menu-2nd-item-3')}
          </Link>
        </div>
      </div>
      <Link href={`/${locale}/about-us`}>{t('mobile-menu-3rd')}</Link>
      <Link
        href={`https://sundose.zendesk.com/hc/pl/categories/360002268019-FAQ`}
      >
        {t('mobile-menu-4th')}
      </Link>
      {/*<Link href={'#'}>{t('menu-4th')}</Link>*/}
    </>
  );

  return (
    <nav
      className={`${styles.navbar} ${sticky ? styles.sticky : ''}`}
      // @ts-ignore
      ref={appbarRef}
    >
      <div className={styles.withPadding}>
        <div className={styles.innerContainer}>
          <div className={`${styles.leftContainer} ${styles.firstPart}`}>
            <div style={{ cursor: 'pointer' }}>
              <Link href={`/${locale}/projects`} passHref>
                <Image
                  layout="fixed"
                  width="76"
                  height="50"
                  src={UELogo}
                  alt="UE Projects"
                />
              </Link>
            </div>
            <div className={styles.navList}>{links}</div>
          </div>

          <div className={`${styles.center}`}>
            <Image
              src={SundoseLogo}
              alt="Sundose Logo"
              width={130}
              height={43}
              layout="fixed"
            />
          </div>

          <div className={`${styles.links} ${styles.secondPart}`}>
            <LanguagePicker />
            <div className={styles.loginLink}>
              <Image src={ProfileIcon} alt="Profile icon" />
              <Link locale={false} href={`/app/panel/auth/login/`}>
                {t('login')}
              </Link>
            </div>
            <CtaButton
              customClassName={styles.customCtaButtom}
              inNavbar
              text={t('cta-button')}
            />
          </div>

          <div className={styles.hamburger} onClick={() => setNav(!nav)}>
            <Image
              alt="Hamburger"
              src={HamburgerIcon}
              layout={'fixed'}
              width={48}
              height={48}
            />
          </div>
        </div>
      </div>

      {nav ? (
        <div className={styles.mobileNav}>
          <div className={styles.mobileNavPadding}>
            <Link href="/">{t('mobile-menu-1st')}</Link>
            {links}

            <div className={`split ${styles.mobileNavSplit}`}>
              <div className={`half ${styles.loginLink}`}>
                <Image src={ProfileIcon} alt="Profile icon" />
                <Link locale={false} href={`/app/panel/auth/login/`}>
                  {t('login')}
                </Link>
              </div>
              <div className={`half ${styles.mobileLanguagePicker}`}>
                <LanguagePicker />
              </div>
            </div>

            <div className={`split ${styles.mobileCtaContainer}`}>
              <CtaButton
                customClassName={styles.customCtaButtom}
                inNavbar
                text={t('cta-button')}
              />
            </div>
          </div>
        </div>
      ) : null}
    </nav>
  );
};

export default Appbar;
